export const GENERATION_JOB_STATUS_VALUES = ["pending", "processing", "completed", "failed"];
export const GenerationJobStatus = {
    PENDING: "pending",
    PROCESSING: "processing",
    COMPLETED: "completed",
    FAILED: "failed",
};
export const GENERATION_KIND_VALUES = ["series_cover", "episode_cover", "golden_asset", "keyframe", "end_keyframe", "shot_video"];
export const GenerationKind = {
    SERIES_COVER: "series_cover",
    EPISODE_COVER: "episode_cover",
    GOLDEN_ASSET: "golden_asset",
    KEYFRAME: "keyframe",
    END_KEYFRAME: "end_keyframe",
    SHOT_VIDEO: "shot_video",
};
export const GENERATION_TARGET_TYPE_VALUES = ["series", "story", "character", "location", "shot"];
export const GenerationTargetType = {
    SERIES: "series",
    STORY: "story",
    CHARACTER: "character",
    LOCATION: "location",
    SHOT: "shot",
};
export const GENERATION_FAILURE_REASON_VALUES = [
    "identity_drift",
    "environment_drift",
    "pov_failure",
    "action_failure",
    "transition_failure",
    "visual_artifact",
    "provider_error",
];
export const GenerationFailureReason = {
    IDENTITY_DRIFT: "identity_drift",
    ENVIRONMENT_DRIFT: "environment_drift",
    POV_FAILURE: "pov_failure",
    ACTION_FAILURE: "action_failure",
    TRANSITION_FAILURE: "transition_failure",
    VISUAL_ARTIFACT: "visual_artifact",
    PROVIDER_ERROR: "provider_error",
};
export const GENERATION_FAILURE_REASON_LABELS = {
    [GenerationFailureReason.IDENTITY_DRIFT]: "Dérive d'identité",
    [GenerationFailureReason.ENVIRONMENT_DRIFT]: "Dérive du décor",
    [GenerationFailureReason.POV_FAILURE]: "POV raté",
    [GenerationFailureReason.ACTION_FAILURE]: "Action ratée",
    [GenerationFailureReason.TRANSITION_FAILURE]: "Transition ratée",
    [GenerationFailureReason.VISUAL_ARTIFACT]: "Artefact visuel",
    [GenerationFailureReason.PROVIDER_ERROR]: "Erreur du fournisseur",
};
export const CLIP_VIDEO_DURATION_VALUES = [5, 10];
export const DEFAULT_CLIP_VIDEO_DURATION = 5;
export const ESTIMATED_IMAGE_COST_USD = 0.08;
export const ESTIMATED_SHOT_VIDEO_COST_USD = 0.35;
